export default __webpack_public_path__ + "static/media/journal.1dd59644.svg";